import {DateTime} from 'luxon';

/**
 * A report date as the calendar day the admin picked, `yyyy-MM-dd`. The API turns it into the game's local day, so it
 * must never be sent as an instant: a UTC timestamp is already the next day on a PEI evening.
 */
export function reportDay(valueP: DateTime | Date | string): string {
  if (DateTime.isDateTime(valueP)) {
    return valueP.toISODate()!;
  }
  if (valueP instanceof Date) {
    return DateTime.fromJSDate(valueP).toISODate()!;
  }
  return valueP.slice(0, 10);
}
